export enum ClaimsEnum {
  Admin = 'https://accounts.linq.com/admin',
  ErpUserId = 'https://accounts.linq.com/userAuthId',
  IsSuperUser = 'isSuperUser',
  Email = 'https://accounts.linq.com/email',
  Name = 'https://accounts.linq.com/name',
  FirstName = 'https://accounts.linq.com/firstName',
  LastName = 'https://accounts.linq.com/lastName',
}
